export default {
  title: 'Channels',
  analytics: {
    title: 'Channel Analytics',
  },
  createChannelButton: 'Create a new channel',
  createChannelModalTitle: 'Create a new channel',
  general: {
    on: 'on',
    before: 'previous',
    next: 'next',
    ending: 'finish',
    media: 'medias',
    categories: 'categories',
    activate: 'activate',
    with: 'with',
    without: 'without',
    onRequest: 'on request',
    copy: 'Copy',
    name: 'Name',
    emptyData: 'No data available',
    send: 'Send',
    modify: 'Modify',
    personalize: 'Personalize',
    save: 'Save',
    title: 'Title',
    description: 'Description',
    miniature: 'Miniature',
    favicon: 'Favicon',
    writeBelow: 'Write below:',
    preview: 'Preview:',
    delete: 'Delete',
    addItem: 'Add content',
    archive: 'Archive',
    add: 'Add',
  },
  emptyState: {
    title: 'Start creating your channel',
    description: 'This feature allows you to create your platform to share with your community.',
    buttonText: 'Get Started'
  },
  listChannels: {
    title: 'Your Channels List',
    createChannelButton: 'Create a new channel',
    edit: 'Edit',
    delete: 'Delete',
  },
  errors: {
    createChannelFailed: 'Failed to create channel',
    createChannelApiError: 'Error while creating the channel'
  },
  onboarding: {
    firstStep: 'First Step',
    step1: {
      title: 'Add content to your channel',
      action1: 'Create your category',
      action2: 'Add content from your library',
      action3: 'Sort and organize'
    },
    step2: {
      title: 'Manage your privacy',
      action1: 'Enable or disable the authentication system',
      action2: 'Choose the login mode',
      action3: 'Manage the user list if any'
    },
    step3: {
      title: 'Monetize your content',
      action1: 'Enable monetization',
      action2: 'Wait for our validation',
      action3: 'Create your Stripe account',
      action4: 'Choose your pricing'
    },
    step4: {
      title: 'Customize your channel',
      action1: 'Select a theme that fits your needs',
      action2: 'Customize to reflect your brand',
      action3: 'Preview how your channel looks',
    }
  },
  details: {
    seeChannel: 'See the channel',
    loading: 'Loading channel...',
    editTheme: 'Edit Theme',
    viewChannel: 'View Channel',
    channelId: 'Channel ID',
    status: {
      online: 'Online',
      offline: 'Offline'
    },
    error: {
      loadFailed: 'Failed to load channel details'
    },
    sections: {
      main: 'Overview',
      content: 'Content',
      settings: 'Configuration'
    },
    menu: {
      dashboard: 'Dashboard',
      categories: 'Categories',
      users: 'Users',
      itemLabel: 'Items',
      itemTitle: 'All items',
      sale: 'Sales',
      analytics: 'Analytics',
      editorLabel: 'Theme Editor',
      paramLabel: 'Settings',
      stats: 'Analytics'
    }
  },
  dashboard: {
    hoverMenu: {
      editSEO: 'Edit information (SEO)',
      editURL: 'Edit URL',
      editDesign: 'Edit design'
    },
    seeChannel: 'See the channel',
    latestCategories: {
      title: 'Latest Categories',
      emptyState: {
        title: 'No category created',
        description: 'Create a category to start adding content.',
        buttonText: 'Create a first category'
      }
    },
    latestItems: {
      title: 'Latest items posted',
      subtitle: 'Add items to enrich your channel',
      emptyState: {
        title: 'No item created',
        messageWithoutCategories1: 'Create a first category',
        messageWithoutCategories2: 'to add items from your library.',
        messageWithCategories: 'No media for now',
      }
    },
    latestUsers: {
      title: 'Latest created users',
      btnTitle: 'Configure security',
    },
    monetization: {
      title: 'Sell your content',
      description: 'Generate revenue by monetizing your content. Enable this feature to offer premium content to your subscribers.',
    },
    subscriptionMonetization: {
      title: 'Sell your videos',
      description1: 'You can monetize your channel by offering subscriptions or selling/renting your videos individually.',
      description2: 'Activation is free. A commission will be automatically deducted from your sales.',
      commissionFees: 'Commission Fees',
      percentage: '10 %',
      btnDescription: 'Click the button below to request activation of this option on your channel.',
    },
    stats: {
      title: 'Statistics',
      subtitle: 'Over the last 30 days',
      tooltip: 'See all statistics',
    },
  },
  categories: {
    title: 'Categories',
    description: 'Reorganize your categories by drag-and-drop to define their order or hierarchy.',
    btnCreateCategory: 'Create a category',
    emptyState: {
      title: 'No category created',
      description: 'Click "Create a category" to add your first category.',
    },
    editCategory: {
      btnBack: 'Back to categories',
      btnAddContent: 'Add item',
      info: 'Information',
      access: 'Access rights',
      items: 'Items',
      btnDelete: 'Delete this category',
      info: {
        title1: 'Visibility on the homepage',
        subtitle1: 'Disabling this option will make this category visible on the homepage.',
        title2: 'Visibility in search results',
        subtitle2: 'Disabling this option will make this category visible in search results.',
        title3: 'Show in the navbar',
        subtitle3: 'Disabling this option will remove this category from the navbar.',
      },
      accessRights: {
        description1:' The access rights defined here will apply to all videos in this category.',
        description2:'Unlisted',
        description3:'of this category.',
        description4:'You can also set access rights on each video in this category.',
        description5:'If you add a new video to this category, it will automatically inherit the access rights defined here.',
        description6:'Note that the rights only apply to videos in this category and not to subcategories.',
        btnAddAccessRight: 'Add an access right',
        modal: {
          title: 'Allow access to this item',
          users: 'Users',
          groups: 'Groups',
          search: 'Search by email',
          emptyState: 'No users available',
          save: 'Save',
          email: 'Email',
        },
      },
      items: {
        emptyState:'No items created in this category',
        btnDeleteSelected: 'Delete selected items',
        preview: 'Preview',
        public: 'Public',
        private: 'Private',
        notListed: 'Unlisted',
        paid: 'Paid',
        videoSorting: 'Video sorting',
        videoSortingText: 'Choose the display order of the videos in this category within the channel.',
        name: 'Name',
        publishedOn: 'Published on',
        visibility: 'Visibility',
        manualSorting: 'Manual sorting',
      }
    }
  },
  items: {
    title: 'All items',
    btnAddItem: 'Add item',
    tooltip: 'Create your first category before adding item',
    searchPlaceholder: 'Search content',
    filterByCategory: 'Category',
    filterByType: 'Type',
    filterByVisibility: 'Visibility',
    noSearchResults: 'No content found',
    tryDifferentSearch: 'Try adjusting your filters or search terms',
    emptyState: 'No content posted yet',
    emptyDescription: 'Start by adding content from your library to this channel',
    btnAdd: 'Add content',
    premium: 'Premium',
    deleteTitle: 'Delete content',
    deleteMessage: 'Are you sure you want to remove "{title}" from this channel?',
    table: {
      title: 'Title',
      publishedAt: 'Published',
      views: 'Views',
    },
    types: {
      video: 'Video',
      image: 'Image',
      audio: 'Audio',
      document: 'Document',
      collection: 'Collection',
    },
    visibility: {
      public: 'Public',
      authenticated: 'Authenticated',
      restricted: 'Restricted',
    },
    description1: 'Below is a list of the item in your library that you have published on your channel.',
    description2: 'Edit the categories of each item as well as their access rights by clicking on the icon.',
    item: {
      menu: {
        mediabox: 'See in Mediabox',
        statistics: 'See statistics',
      },
      alertMonetization: 'This content is available for free on your channel. To sell it, enable monetization.',
      informations: {
        title: 'Information',
        publishedAt: 'Published at',
        category: 'Category',
        url: 'URL',
      },
      subscription: {
        title: 'Subscription',
        switch1: 'Available on all your subscriptions.',
        switch2: 'Show a preview of this content to non-subscribers.',
        subscriptionName: 'Subscription name',
      },
      pricing: {
        title: 'Pricing',
        priceSelect: 'Select a price',
      },
      access: {
        title: 'Access',
        allowDownload: 'Allow media download.',
        restrictAccess: 'Restrict access to this content',
        whoCanAccess: 'Who can access this content?',
        public: 'Public',
        auth: 'Authenticated',
        restricted: 'Restricted access',
        publicAlert: 'This content is accessible to anyone who visits your channel.',
        authAlert: 'This content is only accessible to authenticated users.',
        restrictedAlert: 'This content is only accessible to the authenticated users selected below.',
        btnAddAccessRight: 'Add an access right',
        previewLabel: 'Allow unauthenticated users to see a preview of this content',
      },
  },
  },
  users: {
    title: 'Access / Accounts',
    btnInvite: 'Invite users',
    btnCreateGroup: 'Create a group',
    description: 'Manage the users of your channel. You can add users, edit their access rights, and delete them if necessary.',
    searchPlaceholder: 'Search for a user',
    filterByGroup: 'Filter by group',
    filterByStatus: 'Filter by status',
    deleteConfirmTitle: 'Delete user',
    deleteConfirmMessage: 'Are you sure you want to delete this user? This action cannot be undone.',
    reactivateSuccess: 'User reactivated successfully',
    reactivateError: 'Error reactivating user',
    deleteSuccess: 'User deleted successfully',
    deleteError: 'Error deleting user',
    updateSuccess: 'User updated successfully',
    updateError: 'Error updating user',
    showInviteLink: 'Show invitation link',
    resendInvitation: 'Resend invitation',
    noSearchResults: 'No users found',
    tryDifferentSearch: 'Try adjusting your filters or search term',
    emptyDescription: 'Start by inviting users to your channel',
    emptyState: {
      users: 'No users',
      groups: 'No groups yet',
    },
    tabs: {
      users: 'Users',
      groups: 'Groups',
      invites: 'Invitation links',
      information: 'General Information',
      access: 'Access Rights',
      statistics: 'Statistics',
    },
    table: {
      email: 'Email',
      name: 'Name',
      groups: 'Groups',
      joinedAt: 'Joined',
    },
    badges: {
      inactive: 'Inactive',
      staff: 'Staff',
      owner: 'Owner',
    },
    status: {
      all: 'All',
      active: 'Active',
      inactive: 'Inactive',
    },
    usersTab: {
      btnExport: 'Export (.xlsx)',
      btnInvite: 'Send invitations',
      searchPlaceholder: 'Search for a user',
      filterAll: 'All',
      filterRegistered: 'Registered',
      filterPending: 'Pending',
      table: {
        email: 'Email',
        lastName: 'Last Name',
        firstName: 'First Name',
        createdAt: 'Created At',
        copyLink: 'Copy Invitation Link',
        resendInvitation: 'Resend Invitation',
        viewUser: 'View User',
        btnDeleteSelected: 'Delete User',
        menu: {
          edit: 'Modifier',
          resend: 'Renvoyer',
          link: 'Lien d\'invitation',
          pendingStatus: 'En attente',
        }
      },
      modal: {
        description: 'The emails added to this list will automatically receive an invitation to create their account on the channel.',
        title: 'Invite users to your channel',
        text1: 'Copy and paste the list of emails below',
        text2: 'You can copy and paste a complete list, even with unnecessary information, we will filter it to retrieve only the emails.',
        title2: 'Associate these users with a group',
        description2: 'Users in the same group share the same properties. When inviting many users, it is advisable to add them to a group to simplify your organization later.',
        selectGroup: 'SSelect one or more groups',
        title3: 'Expiration of user accounts',
        description3: 'You can set a date when the accounts of the users below will be disabled. These users will no longer be able to log in to your channel.',
        noExpiration: 'No expiration set',
      },
      },
      pickers: {
        groups: {
          placeholder: 'Select groups',
          noResults: 'No groups found',
          typeToSearch: 'Type to search groups',
        },
      },
      groups: {
        table: {
          name: 'Name',
          description: 'Description',
          usersCount: 'Number of Users',
        },
        emptyDescription: 'Create groups to manage your users permissions',
        noSearchResults: 'No groups found',
        tryDifferentSearch: 'Try a different search term',
        deleteTitle: 'Delete group',
        deleteMessage: 'Are you sure you want to delete this group? This action cannot be undone.',
        deleteSuccess: 'Group deleted successfully',
        deleteError: 'Error deleting group',
        deleteErrorMessage: 'Failed to delete the group. Please try again.',
        createError: 'Error creating group',
        createErrorMessage: 'Failed to create the group. Please try again.',
        createModal: {
          title: 'Create a group',
          nameLabel: 'Group name',
          namePlaceholder: 'e.g. Marketing Team',
          descriptionLabel: 'Description (optional)',
          descriptionPlaceholder: 'Describe the role or purpose of this group...',
          nameRequired: 'Group name is required',
          nameTooShort: 'Name must be at least 2 characters',
          nameTooLong: 'Name cannot exceed 100 characters',
        },
        newGroup: 'New group',
        addMembers: 'Add members',
        noMembers: 'No members in this group',
        addFirstMember: 'Add first member',
        saveGroupFirst: 'Save the group to enable this tab',
        memberRemovedSuccess: 'Member removed successfully',
        membersAddedSuccess: '{count} member(s) added successfully',
        invalidForm: 'Please fill in all required fields',
        createSuccess: 'Group created successfully',
        updateSuccess: 'Group updated successfully',
        updateError: 'Error updating group',
        removeMemberTitle: 'Remove member',
        removeMemberMessage: 'Are you sure you want to remove {name} from the group?',
        removeMemberError: 'Error removing member',
        accessComingSoon: 'Content access management coming soon',
        tabs: {
          information: 'Information',
          members: 'Members',
          access: 'Access',
        },
        fields: {
          name: 'Group name',
          namePlaceholder: 'e.g. Marketing Team',
          description: 'Description',
          descriptionPlaceholder: 'Describe the role or purpose of this group...',
          isActive: 'Active group',
        },
        sections: {
          information: {
            title: 'Information',
            description: 'Group name and description.',
          },
          members: {
            title: 'Members',
            description: 'Users in this group.',
          },
          access: {
            title: 'Content Access',
            description: 'Content accessible by this group and access management.',
          },
        },
        table: {
          member: 'Member',
          joinedAt: 'Joined date',
        },
        groupDetails: {
          btnAddUsers: 'Add users',
          informations: 'Informations',
          groupeName: 'Group name',
          groupeNamePlaceholder: 'Enter group name',
          expirationDate: 'Expiration date',
          expirationDatePlaceholder: 'Group expiration date',
          noExpiration: 'No expiration date set',
          usersList: 'User list',
          emptyGroup: 'No users in this group',
          table: {
            email: 'Email',
            firstName: 'First Name',
            lastName: 'Last Name',
            createdAt: 'Created At',
          },
          addUsersModal: {
            title: 'Add users',
            searchUser: 'Search for a user',
            noUsers: 'No users',
            email: 'Email',
            lastName: 'Last Name',
            firstName: 'First Name',
          },
        },
      },
    userSelectionModal: {
      title: 'Select Users',
      searchPlaceholder: 'Search by name or email...',
      noUsersFound: 'No users found',
      tryDifferentSearch: 'Try a different search term',
      noAvailableUsers: 'No users available to add',
      user: 'User',
      joinedAt: 'Joined',
      lastActivity: 'Last Activity',
      owner: 'Owner',
      staff: 'Staff',
      inactive: 'Inactive',
      addUser: 'Add User',
      addUsers: 'Add {count} Users',
    },
  },
  monetization: {
    subscriptions: {
      title: 'Subscriptions',
      newSubscription: 'New Subscription',
      btnCreate: 'Create Subscription',
      searchPlaceholder: 'Search subscriptions...',
      filterByStatus: 'Filter by status',
      filterByPeriod: 'Filter by period',
      noSearchResults: 'No subscriptions found',
      tryDifferentSearch: 'Try adjusting your filters or search terms',
      deleteTitle: 'Delete Subscription',
      deleteMessage: 'Are you sure you want to delete the subscription "{name}"? This action cannot be undone.',
      createError: 'Failed to create subscription',
      updateError: 'Failed to update subscription',
      deleteError: 'Failed to delete subscription',
      noSubscriptions: 'No subscriptions yet',
      noSubscriptionsDescription: 'Create your first subscription to start monetizing your content.',
      createFirstSubscription: 'Create First Subscription',
      table: {
        name: 'Name',
        price: 'Price',
        subscribers: 'Subscribers',
        createdAt: 'Created',
        status: 'Status',
      },
      status: {
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
      },
      periods: {
        all: 'All periods',
        monthly: 'Monthly',
        yearly: 'Yearly',
        weekly: 'Weekly',
      },
      headers: {
        name: 'Name',
        price: 'Price',
        period: 'Period',
        subscribers: 'Subscribers',
        status: 'Status',
      },
      tabs: {
        information: 'Information',
        items: 'Content',
        subscribers: 'Subscribers',
      },
      sections: {
        information: {
          title: 'Subscription Details',
          description: 'Configure the subscription name, pricing, and settings.',
        },
        items: {
          title: 'Subscription Content',
          description: 'Manage the content available to subscribers of this plan.',
        },
        subscribers: {
          title: 'Subscribers',
          description: 'View and manage users subscribed to this plan.',
        },
      },
    },
    prices: {
      title: 'Prices',
      newPrice: 'New Price',
      deleteTitle: 'Delete Price',
      deleteMessage: 'Are you sure you want to delete this price? This action cannot be undone.',
      createError: 'Failed to create price',
      updateError: 'Failed to update price',
      deleteError: 'Failed to delete price',
      noPrices: 'No prices yet',
      noPricesDescription: 'Create your first price to start selling individual content.',
      createFirstPrice: 'Create First Price',
    },
    coupons: {
      title: 'Promo Codes',
      description: 'Create discount codes to offer special promotions to your customers.',
      btnCreate: 'Create Promo Code',
      newCoupon: 'New Promo Code',
      searchPlaceholder: 'Search promo codes...',
      filterByStatus: 'Filter by status',
      noSearchResults: 'No promo codes found',
      tryDifferentSearch: 'Try adjusting your filters or search terms',
      createError: 'Failed to create promo code',
      updateError: 'Failed to update promo code',
      deleteError: 'Failed to delete promo code',
      deleteTitle: 'Delete Promo Code',
      deleteMessage: 'Are you sure you want to delete the promo code "{code}"? This action cannot be undone.',
      noCoupons: 'No promo codes yet',
      noCouponsDescription: 'Create your first promo code to offer discounts to your customers.',
      createFirstCoupon: 'Create First Promo Code',
      searchUsage: 'Search usage history...',
      export: 'Export',
      noUsage: 'No usage yet',
      noUsageDescription: 'This promo code has not been used yet.',
      expired: 'Expired',
      maxReached: 'Limit reached',
      unlimited: 'Unlimited',
      noExpiration: 'No expiration',
      table: {
        code: 'Code',
        discount: 'Discount',
        usage: 'Usage',
        expiry: 'Expiry',
        status: 'Status',
      },
      status: {
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
        expired: 'Expired',
      },
      daysLeft: '{days} days left',
      headers: {
        code: 'Code',
        discount: 'Discount',
        usage: 'Usage',
        expiry: 'Expiry',
        status: 'Status',
      },
      tabs: {
        information: 'Information',
        usage: 'Usage History',
      },
      sections: {
        information: {
          title: 'Promo Code Details',
          description: 'Configure the discount code and its usage limits.',
        },
        statistics: {
          title: 'Usage Statistics',
          description: 'Overview of how this promo code has been used.',
        },
        usage: {
          title: 'Usage History',
          description: 'Detailed list of all customers who have used this promo code.',
        },
      },
      fields: {
        code: 'Promo Code',
        codePlaceholder: 'e.g., SUMMER20',
        codeHint: 'Alphanumeric characters, hyphens, and underscores only',
        discountType: 'Discount Type',
        discountValue: 'Discount Value',
        currency: 'Currency',
        usageLimits: 'Usage Limits',
        limitTotalUsage: 'Limit total number of uses',
        limitPerCustomer: 'Limit uses per customer',
        maxRedemptionsPlaceholder: 'e.g., 100',
        maxPerCustomerPlaceholder: 'e.g., 1',
        expiration: 'Expiration',
        setExpiration: 'Set expiration date',
        isActive: 'Active promo code',
      },
      types: {
        percentage: 'Percentage',
        fixedAmount: 'Fixed Amount',
      },
      validation: {
        codeRequired: 'Promo code is required',
        codeTooLong: 'Code must be 50 characters or less',
        codeTooShort: 'Code must be at least 3 characters',
        codeInvalid: 'Code can only contain letters, numbers, hyphens, and underscores',
        valueRequired: 'Discount value is required',
        valuePositive: 'Value must be greater than zero',
        percentMax: 'Percentage cannot exceed 100%',
      },
      stats: {
        totalUsage: 'Total Uses',
        totalDiscount: 'Total Discounts Given',
        remainingUsage: 'Remaining Uses',
        expiresIn: 'Expires In',
      },
      table: {
        user: 'Customer',
        date: 'Date',
        subscription: 'Subscription',
        discount: 'Discount',
        finalPrice: 'Final Price',
      },
    },
  },
  sale: {
    tabs: {
      subscription: 'Subscriptions',
      tarif: 'Tariffs',
      promo: 'Promo Codes',
    },
    subscription: {
      description: 'Create your subscriptions and link them to your different categories and content.',
      btnCreate: 'Create a subscription',
      headers: {
        name: 'Name',
        tarif: 'Tariff',
        createdAt: 'Created At',
        activeSubscribers: 'Active Subscribers',
        status: 'Status',
      },
      deleteModal: {
        title: 'Delete this subscription',
        description: 'Are you sure you want to delete this subscription? This action is irreversible.',
      },
      details: {
        tabs: {
          informations: 'Informations',
          subscribers: 'Subscribers',
          items: 'Items',
        },
        informations: {
          draftMode: 'Draft Mode',
          activated: 'activated',
          desactivated: 'deactivated',
          draftActivatetext: 'This subscription is currently in draft mode, it is not yet published or accessible to users.',
          draftDesactivateText: 'This subscription is published and accessible to users.',
          subscriptionName: 'Subscription Name',
          description: 'Description',
          descriptionPlaceholder: 'Subscription description',
          image: 'Image',
          subscriptionType: 'Subscription Type',
          recurrent: 'Recurrent',
          punctual: 'Punctual',
          tariff: 'Tariff',
          tariffPlaceholder: 'Price in €',
          billingPeriod: 'Billing Period',
          autoRenewal: 'Auto Renewal',
          trialPeriod: 'Trial Period',
          noTrialPeriod: 'No Trial Period',
          restrictAccess: 'Restrict Access to this Subscription',
          restrictAccessText: 'Only users who enter the password below will be able to subscribe to the subscription. By default, all users can subscribe to this subscription.',
          password: 'Password',
          period: {
            monthly: 'Monthly',
            quarterly: 'Quarterly',
            yearly: 'Yearly',
            halfYearly: 'Half-Yearly',
            month: 'Month',
            day: 'Day',
            days: 'Days',
            custom: 'Custom',
          },
        },
      },
    },
    tarif: {
      description: 'Create your tariffs and select in the contents the tariff you want to associate with your media.',
      btnCreate: 'Create a new tariff',
      headers: {
        name: 'Name',
        tarif: 'Tariff',
        period: 'Period',
        download: 'Download',
      },
      deleteModal: {
        title: 'Delete this tariff',
        description: 'Are you sure you want to delete this tariff? This action is irreversible.',
      },
    },
    promo: {
      description: 'A promo code can be used to offer a discount to a customer at checkout.',
      btnCreate: 'Create a promo code',
      headers: {
        code: 'Code',
        reduction: 'Reduction',
        use: 'Uses',
        expiresAt: 'Expires At',
      },
      deleteModal: {
        title: 'Delete this promo code',
        description: 'Are you sure you want to delete this promo code? This action is irreversible.',
      },
    },
  },
  settings: {
    title: 'General settings',
    description: 'Manage the settings and options related to your channel.',
    tabs: {
      domain: 'Channel link',
      seo: 'Channel name and description',
      legal: 'Legal notices / TOS - Privacy Policy',
      auth: 'Authentication system',
      contact: 'Contact form',
      options: 'Options',
      monetization: 'Video sales',
    },
    domain: {
      title: 'Channel Domains',
      description: 'Manage the domains for your channel. Your channel will be accessible from the primary domain.',
      primaryDomain: 'Primary Domain',
      secondaryDomains: 'Secondary Domains',
      noPrimaryDomain: 'No primary domain configured. Add a domain to get started.',
      noDomainsTitle: 'No domains configured',
      noDomainsDesc: 'Start by adding a Videas subdomain or your custom domain to make your channel accessible online.',
      addDomain: 'Add Domain',
      addFirstDomain: 'Add Your First Domain',
      aboutPrimaryDomain: 'About Primary Domain',
      primaryDomainInfo: 'The primary domain is the main URL where your channel is accessible. Secondary domains redirect to the primary domain.',
      sslCertificates: 'SSL Certificates',
      sslInfo: 'All domains are automatically secured with SSL certificates for encrypted connections.',
      needHelp: 'Need Help?',
      helpDescription: 'Our support team is here to help you configure your custom domains.',
      contactSupport: 'Contact Support',

      // Custom domain banner
      customDomainBanner: {
        title: 'Boost Your Brand with a Custom Domain',
        description: 'Take your channel to the next level with your own professional domain name. Stand out from the crowd and build trust with your audience.',
        cta: 'Get Your Custom Domain',
        pricing: 'Starting at €10/month',
        benefits: {
          professional: 'Professional appearance',
          branding: 'Strengthen your brand',
          seo: 'Better SEO ranking',
          trust: 'Build customer trust'
        }
      },

      // Domain card
      primary: 'Primary',
      default: 'Default',
      status: {
        active: 'Active',
        pending: 'Pending',
        error: 'Error'
      },
      dnsPending: 'DNS configuration required',
      viewDnsInstructions: 'View DNS Instructions',
      configureNow: 'Configure now',
      configureDns: 'Configure DNS',
      pendingMessage: 'DNS configuration is pending. Please configure your DNS records to activate this domain.',
      checkNow: 'Check now',
      verifiedAt: 'Verified {date}',
      sslActive: 'Active',
      sslPending: 'Pending',
      makePrimary: 'Set as Primary',
      checkStatus: 'Check Status',
      remove: 'Remove',

      // Delete domain modal
      deleteDomain: {
        title: 'Delete Domain',
        warning: 'This action is permanent and cannot be undone',
        consequences: 'Deleting this domain will immediately make your channel inaccessible at this address.',
        domainLabel: 'Domain to delete',
        importantTitle: 'Important',
        consequence1: 'Your channel will no longer be accessible at this address',
        consequence2: 'Any links shared using this domain will stop working',
        consequence3: 'You can add this domain again later if needed',
        confirmLabel: 'I understand the consequences and want to delete this domain',
        deleteButton: 'Delete Domain'
      },

      // Add domain modal
      chooseDomainType: 'Choose your domain type',
      videasSubdomain: 'Videas Subdomain',
      videasSubdomainDesc: 'Quick and free - use a subdomain on videastv.com',
      customDomain: 'Custom Domain',
      customDomainDesc: 'Use your own domain name for a professional appearance',
      customDomainPricing: {
        title: 'Monthly subscription',
        price: '€10/month',
        description: 'Billed monthly to your subscription',
        included: 'SSL certificate, automatic DNS configuration, and 24/7 support included'
      },
      subdomainPlaceholder: 'my-channel',
      customDomainPlaceholder: 'example.com or video.example.com',
      preview: 'Preview',
      rootDomain: 'Root Domain',
      subdomain: 'Subdomain',
      stepChoose: 'Choose Domain',
      stepReview: 'Review & Confirm',
      reviewTitle: 'Review your configuration',
      domainLabel: 'Domain',
      typeLabel: 'Type',
      rootDomainInfo: 'Root domain (requires A record)',
      subdomainInfo: 'Subdomain (requires CNAME record)',
      instantActivation: 'This domain will be activated immediately!',
      nextSteps: 'Next Steps',
      step1Title: 'Configure DNS',
      step1Desc: 'Add the required DNS records at your domain provider',
      step2Title: 'Wait for Propagation',
      step2Desc: 'DNS changes can take up to 24 hours to propagate',
      step3Title: 'Automatic Activation',
      step3Desc: 'Your domain will be automatically activated once DNS is verified',
      activate: 'Activate',
      addAndConfigure: 'Add & Configure',
      setPrimaryLabel: 'Set as primary domain',
      setPrimaryDescription: 'Your channel will be primarily accessible from this domain. Other domains will redirect to it.',
      subdomainRequired: 'Subdomain is required',
      maxLength: 'Maximum {max} characters',
      slugFormat: 'Use lowercase letters, numbers, and hyphens only',
      domainRequired: 'Domain is required',
      invalidDomain: 'Invalid domain format',

      // DNS instructions modal
      dnsConfiguration: 'DNS Configuration',
      dnsConfigured: 'DNS is properly configured!',
      dnsInstructionsTitle: 'Configure your DNS records',
      dnsInstructionsDesc: 'Add the following DNS records at your domain provider to activate your custom domain.',
      requiredRecords: 'Required DNS Records',
      recordType: 'Type',
      recordName: 'Name/Host',
      recordValue: 'Value',
      recordTTL: 'TTL',
      copiedToClipboard: 'Copied to clipboard!',
      providerInstructions: 'Provider-specific instructions',
      otherProvider: 'Other',
      ovh: {
        step1: 'Log in to your OVH manager',
        step2: 'Go to the DNS zone section',
        step3: 'Add the records shown above',
        step4: 'Save and wait for propagation'
      },
      cloudflare: {
        step1: 'Log in to your Cloudflare dashboard',
        step2: 'Select your domain',
        step3: 'Go to DNS settings and add the records',
        step4: 'Ensure proxy is disabled for these records'
      },
      gandi: {
        step1: 'Log in to your Gandi account',
        step2: 'Access the DNS records section',
        step3: 'Add the records as shown',
        step4: 'Activate the changes'
      },
      genericInstructions: 'Log in to your domain provider\'s control panel and add the DNS records shown above. The exact steps vary by provider.',
      verification: 'Verification',
      propagationInfo: 'DNS propagation can take up to 24 hours. We\'ll automatically verify and activate your domain.',
      checkDns: 'Check DNS',
      dnsChecker: 'DNS Checker Tool',
      lastCheck: 'Last checked: {time}',
      configurationComplete: 'Configuration Complete!',
      dnsActive: 'DNS records verified',
      domainReady: 'Your domain is ready to use',

      // Old keys below for compatibility
      subtitle: 'Choose the link at which your channel will be available using a free address provided by Videas or link your site to your own domain name.',
      subtitle: 'Choose the link at which your channel will be available using a free address provided by Videas or link your site to your own domain name.',
      domainVideas: 'Use one of our custom domains',
      domainVideasText: 'You can use our domain videastv.com if you do not have your own domain name yet.',
      domainVideasAlert: 'Warning, if you change the URL, your channel will be unavailable at the old URL. If you have already shared the previous link, it will no longer be valid.',
      domainCustom: 'Your own domain name',
      domainCustomText: "Give your channel a more professional appearance by putting it on your own domain rather than using a domain on videastv.com.\nContact us to set up your domain.",
      domainCustomized: "Customized domain",
      domainCustomizedText: "You are using a custom domain for this channel.\nFor any changes, please contact support.",
      customDomain: {
        title: 'Custom domain',
        description1: 'You have a domain name and want to point your channel to this domain name or a subdomain?',
        description2: 'This option is charged and will be automatically added to your current subscription.',
        monthlySubscription: 'Monthly subscription',
        monthlySubscriptionText: 'Custom domain name',
        monthlySubscriptionTarif: '10 € / month',
        indicateUrl: 'Indicate below the full URL you want for your channel:',
        label: 'Channel URL',
        btnDescription: 'Click the button below to request activation of this option on your channel. Our team will get back to you as soon as possible with the configuration to be done at the DNS level.',
        tooltip: 'It is necessary to publish your channel to activate the custom domain name.',
        btnSubmit: 'Submit my request',
      }
    },
    seo:{
      channelName: "Channel name",
      channelDescription: "Describe your channel",
    },
    legal: {
      description: 'Insert your legal items. They will appear in the footer of your channel.',
      "sample": "*This is markdown :*\n# corresponds to a title\n## corresponds to a subtitle\n### and so on\n**allows you to make text bold**\nFor more examples : https://stackedit.io/app#\n\n---------------------\n\n# Legal notices\n\n## Publisher\nName surname\n11 rue des lilas\n59000 Lille\nhttps://monsite.fr\n\n## Host\nVIDEAS SAS\nhttps://videas.fr\n4702 Chemin de l’aventure\n59236 Frelinghien\nFRANCE\nSiret : 83435667700015\ncontact@videas.fr",
    },
    auth: {
      description: 'Define whether your channel is accessible privately or publicly. You have the option to enable user accounts on your channel.',
      alert: "Once monetization is enabled, only user authentication mode is allowed.",
      text2: "Allow users to log in to access your channel or private content.",
      text3: "A login button will appear on your channel.",
      authEnable: "Enable authentication",
      chooseAuthMethod: "Choose the login method",
      passwordMethod: "Single password",
      passwordText: " Users will be able to log in to your channel to access private content using the password you set below. The password is the same for all users.",
      usersMethod: "User accounts",
      usersText: "Users will be able to log in to your channel to access private content using a user account (username/password).",
      enableRegistration: "Allow users to register on the channel without your invitation.",
      forcedAuth: "Forced authentication",
      enableForcedAuth: "Users must authenticate to access your channel.",
      auth: "Auth",
      groupsUsers: "User groups",
      passwordField:"The password below is to be given to users you want to grant access to",
      enterPassword: "Enter a password",
      userRegistration: "User registration",
      userRegistrationText: "Allow users to create an account on the channel without validation or invitation from you.",
      required: "Required authentication",
      requiredText: "By enabling this option, no content will be publicly accessible.\nOnly authenticated users will be able to access your channel.\nA login page will appear directly when someone goes to your channel's address.",
      loginPage: "Login page",
    },
    contact: {
      title: 'Contact form',
      description: 'Define the address to which you want to receive emails from the contact form on the channel.',
      text: 'By default, contact emails are sent to your account address. To send to another address, modify the field below.',
    },
    options:{
      switch1Title: 'Share button',
      switch1Text: 'Adds a button below the video that allows users to share a link or embed the player on an external site',
      switch2Title: 'Comments',
      switch2Text: 'Allows logged-in users to post comments under your media. Comments are visible to all users.',
      switch3Title: 'Content submission',
      switch3Text: 'Allows users to submit content from the channel. Submitted content will appear in your library and you will receive a notification for each new submission.',
      sellVideos: 'Sell videos',
      switch4Text: 'Sell your videos by subscription or for purchase/rental directly from your channel.',
      monetizationSubtitle: 'Allow users to give a donation',
      monetizationText: 'By enabling this option, a field will appear in the cart to allow the user to make a donation.',
      monetizationNote: 'Note that this feature does not work for subscriptions.',
      alert:'You can track all your sales on the Stripe interface.'
    },
    monetization: {
      landing: {
        title: 'Start Monetizing Your Content',
        subtitle: 'Turn your videos into revenue with our simple and transparent monetization solution',
        startButton: 'Start Activation',
        features: {
          commission: {
            title: 'Simple Commission',
            description: 'Only 10% on your sales, no hidden fees'
          },
          secure: {
            title: 'Secure Payments',
            description: 'Powered by Stripe for maximum security'
          },
          instant: {
            title: 'Instant Setup',
            description: 'Start selling in just a few minutes'
          },
          analytics: {
            title: 'Detailed Analytics',
            description: 'Track your performance in real-time'
          }
        },
        pricing: {
          title: 'Simple and Transparent Pricing',
          commission: {
            title: 'Videas Commission',
            description: 'On each transaction',
            features: {
              noSetupFees: 'No setup fees',
              noMonthlyFees: 'No monthly subscription',
              payAsYouEarn: 'Pay only when you sell'
            }
          },
          stripe: {
            title: 'Stripe Fees',
            fees: '1.5% + €0.25',
            description: 'Per transaction',
            features: {
              securePayments: 'Secure payment processing',
              globalReach: 'Accept payments worldwide',
              automaticTaxes: 'Automatic tax calculation'
            }
          },
          example: {
            title: 'Example',
            description: 'For a €100 sale, you receive €88.25 after all fees'
          }
        },
        howItWorks: {
          title: 'How It Works',
          step: 'Step',
          steps: {
            configure: {
              title: 'Configure Your Settings',
              description: 'Choose your currency and payment options'
            },
            connectStripe: {
              title: 'Connect Stripe',
              description: 'Link your Stripe account to receive payments'
            },
            setPrices: {
              title: 'Set Your Prices',
              description: 'Create tariffs and subscriptions for your content'
            },
            startSelling: {
              title: 'Start Selling',
              description: 'Your channel is ready to generate revenue'
            }
          }
        },
        faq: {
          title: 'Frequently Asked Questions',
          items: {
            whenPaid: {
              question: 'When do I receive my payments?',
              answer: 'Payments are processed by Stripe and transferred to your bank account according to your Stripe payout schedule, typically within 2-7 business days.'
            },
            whatFees: {
              question: 'What are the total fees?',
              answer: 'Total fees are 10% Videas commission + Stripe processing fees (1.5% + €0.25 per transaction). No hidden fees or monthly charges.'
            },
            canChangePrice: {
              question: 'Can I change my prices later?',
              answer: 'Yes, you can adjust your prices and create new tariffs at any time. Existing subscriptions will continue at their original price.'
            },
            refunds: {
              question: 'How are refunds handled?',
              answer: 'Refunds can be issued through your Stripe dashboard. The Videas commission is also refunded when you process a refund.'
            }
          }
        }
      },
      activation: {
        step: 'Step',
        previous: 'Previous',
        next: 'Next',
        config: {
          title: 'Configure Your Monetization',
          subtitle: 'Set up your payment preferences and tax information',
          currency: {
            label: 'Payment Currency',
            helper: 'Choose the currency for all your transactions'
          },
          paymentMethods: {
            label: 'Payment Methods',
            helper: 'Select which payment options to offer your customers',
            subscriptions: 'Recurring subscriptions',
            purchases: 'One-time purchases',
            rentals: 'Time-limited rentals',
            tips: 'Accept tips from viewers'
          },
          tax: {
            label: 'Tax Information',
            helper: 'Required for tax compliance and invoicing',
            country: 'Business Country',
            vatNumber: 'VAT Number',
            vatPlaceholder: 'Optional (e.g., FR12345678901)'
          }
        },
        stripe: {
          title: 'Connect Your Stripe Account',
          subtitle: 'Stripe handles all payment processing securely',
          security: {
            title: 'Secure Connection',
            description: 'Your banking information is handled directly by Stripe, never stored on our servers'
          },
          requirements: {
            identity: {
              title: 'Identity Verification',
              description: 'Personal or business identification required'
            },
            business: {
              title: 'Business Information',
              description: 'Company details if applicable'
            },
            bank: {
              title: 'Bank Account',
              description: 'Where you\'ll receive your payouts'
            },
            tax: {
              title: 'Tax Details',
              description: 'For proper tax reporting'
            }
          },
          connectButton: 'Connect with Stripe',
          redirectNotice: 'You will be redirected to Stripe to complete the setup'
        },
        success: {
          title: 'Monetization Activated!',
          subtitle: 'Your channel is now ready to generate revenue',
          nextSteps: {
            title: 'Next Steps',
            createTariffs: 'Create your first pricing plans',
            setupSubscriptions: 'Set up subscription offers',
            addPromoCodes: 'Add promotional codes',
            monitorSales: 'Monitor your sales dashboard'
          },
          finishButton: 'Go to Settings'
        }
      },
      settings: {
        status: {
          active: 'Monetization Active',
          description: 'Your channel is set up to accept payments',
          viewDashboard: 'View Dashboard'
        },
        general: {
          title: 'General Settings',
          currency: 'Currency',
          tips: 'Accept Tips',
          edit: 'Edit Settings'
        },
        stripe: {
          title: 'Stripe Account',
          connected: 'Connected',
          accountId: 'Account ID',
          dashboard: 'Open Stripe Dashboard'
        },
        quickActions: {
          title: 'Quick Actions',
          subscriptions: 'Manage Subscriptions',
          tariffs: 'Manage Tariffs',
          promoCodes: 'Promo Codes',
          reports: 'Sales Reports'
        },
        danger: {
          title: 'Danger Zone',
          warning: 'Deactivating monetization will stop all new sales. Existing subscriptions will continue until their expiration.',
          deactivate: 'Deactivate Monetization'
        }
      }
    },
    newsLetter: {
      title: 'Email newsletter',
      description: 'Sends an email every month to users subscribed to the newsletter.',
      btnTest: 'Send test email',
      btnTestDescription: 'A demo email will be sent to the administrator',
    },
    },
}
